import { css } from "@emotion/css";
import { Callout } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import React from "react";
import ephemeralEnvironmentInfoImage from "../assets/ephemeral-env-channel-info.svg";
import { ConfigWizardHelpLayout } from "./ConfigWizardHelpLayout";
import type { ReviewContentProps } from "./ReviewContent";
import { ReviewContent } from "./ReviewContent";
export function SuccessHelp() {
    return (<ConfigWizardHelpLayout title="Ephemeral Environments Channel">
            <p>New releases created in this channel will automatically provision a new ephemeral environment based on environment name template provided (the example above is using branch name). The release is then deployed to that environment.</p>
            <p>The selected parent environment supplies the deployment targets, accounts, and variables that every ephemeral environment inherits.</p>
        </ConfigWizardHelpLayout>);
}
export const successHelpImage = { src: ephemeralEnvironmentInfoImage, altText: "Graphic of a release and a parent environment passing values to an ephemeral environment" };
export function SuccessContent(props: ReviewContentProps) {
    const styles = {
        callout: css({
            margin: `${space[24]} 0`,
        }),
    };
    return (<div>
            <ReviewContent {...props}/>
            <div className={styles.callout}>
                <Callout type="success" title="We've created an ephemeral environment channel for you!">
                    Releases in this channel will provision a new ephemeral environment and deploy to it automatically.
                </Callout>
            </div>
        </div>);
}
